import React from "react";
import Modal from "react-responsive-modal";
import Info from "../../../../assets/svg/info.svg";
import Button from "../../../inputs/Button";
import { useNavigate } from "react-router-dom";
const FailedMessage = ({
  phoneNumber,
  Nin,
  bvn,
  failedType = "phone",
  btnAction = () => {},
  btnLabel = "Okay",
  onClose
}) => {
  const navigate = useNavigate();
  const failureMessage =
    failedType === "bvn" ? (
      <p className="mb-14 text-center">
        Your BVN (<span className="font-bold">{bvn}</span>) is invalid, kindly
        retry or proceed with NIN..
      </p>
    ) : failedType === "Nin" ? (
      <p className="mb-14 text-center">
        It seems the provided NIN (<span className="font-bold">{Nin}</span>) is
        not valid or failed verification.
      </p>
    ) : failedType === "dob" ? (
      <p className="mb-14 text-center">
        The Date of Birth provided does not match the date of birth on your BVN. Kindly re-enter the correct Date of Birth.
      </p>
    ) : (
      <p className="mb-14 text-center">
        It seems the provided phone number (
        <span className="font-bold">{phoneNumber}</span>) is not linked to your
        NIN.
      </p>
    );

  const actionMessage =
    failedType === "bvn" ? (
      <span
        className="text-alat-light font-semibold cursor-pointer"
        onClick={() =>
          navigate("/nin-verification", {
            state: { isAuthenticated: true }
          })
        }
      >
        Proceed with NIN.
      </span>
    ) : failedType === "Nin" ? (
      <span
        className="text-alat-light font-semibold cursor-pointer"
        onClick={onClose}
      >
        Try Retry
      </span>
    ) : failedType === "dob" ? (
      <span
        className="text-alat-light font-semibold cursor-pointer"
        onClick={onClose}
      >
        Verify with OTP
      </span>
    ) :(
      <span
        className="text-alat-light font-semibold cursor-pointer"
        onClick={() =>
          navigate("/bvn-verification", {
            state: { isAuthenticated: true }
          })
        }
      >
        Proceed with BVN.
      </span>
    );

  return (
    <Modal
      classNames={{ modal: "rounded-md p-10 max-w-md" }}
      open
      center
      showCloseIcon={false}
      onClose={onClose}
    >
      <center>
        <div className="mb-8">
          <div className="bg-alat-light-hover w-16 h-16 flex items-center justify-center rounded-md">
            <img className="w-10 h-10" src={Info} alt="Failed" />
          </div>
        </div>
        <h3 className="font-bold text-xl text-alat-light">
          Verification Unsuccessful
        </h3>
        {failureMessage}
        <Button className="w-full" label={btnLabel} onClick={btnAction} />
        <div className="mt-4">{actionMessage}</div>
      </center>
    </Modal>
  );
};

export default FailedMessage;
